export const rewriteToInternal = url => {
  const regex = '^(.*:)//([A-Za-z0-9-.]+)(:[0-9]+)?(.*)$' // eslint-disable-line
  if (url?.match(regex)) {
    return `${process.env.GATSBY_WP_BASE_URL}${url.match(regex)[4]}`
  }
  return ''
}
